import { ComponentLoader } from '../../webana';

import { Login } from './components/login';

export const components: { [key: string]: ComponentLoader } = {
  'antd:Layout': async () => (await import('./components/layout')).Layout,
  'antd:Login': async () => Login,
  'antd:Button': async () => (await import('./components/button')).Button,
  'antd:Icon': async () => (await import('./components/icon')).Icon,
  'antd:Popconfirm': async () =>
    (await import('./components/popconfirm')).Popconfirm,
  'antd:Tooltip': async () => (await import('./components/tooltip')).Tooltip,
  'antd:Card': async () => (await import('./components/card')).Card,
  'antd:Row': async () => (await import('./components/grid')).Row,
  // 'antd:Col': async () => (await import('./components/grid')).Col,
  'antd:Table': async () => (await import('./components/table')).Table,
  'antd:Table2': async () => (await import('./components/table2')).Table2,
  'antd:Form': async () => (await import('./components/form')).Form,
  'antd:FormItem': async () => (await import('./components/form')).FormItem,
  'antd:Input': async () => (await import('./components/input')).Input,
  'antd:DatePicker': async () =>
    (await import('./components/date-picker')).DatePicker,
  'antd:InputTextarea': async () =>
    (await import('./components/input')).InputTextarea,
  'antd:InputGroup': async () =>
    (await import('./components/input')).InputGroup,
  'antd:InputGeosuggest': async () =>
    (await import('./components/input')).InputGeosuggest,
  'antd:InputSearch': async () =>
    (await import('./components/input')).InputSearch,
  'antd:InputNumber': async () =>
    (await import('./components/input-number')).InputNumber,
  'antd:InputGroupList': async () =>
    (await import('./components/input-group-list')).InputGroupList,
  'antd:Checkbox': async () => (await import('./components/checkbox')).Checkbox,
  'antd:Select': async () => (await import('./components/select')).Select,
  'antd:List': async () => (await import('./components/list')).List,
  'antd:Collapse': async () => (await import('./components/collapse')).Collapse,
  'antd:Modal': async () => (await import('./components/modal')).Modal,
  'antd:Tabs': async () => (await import('./components/tabs')).Tabs,
  'Opakovani': async () => (await import('./components/opakovani')).Opakovani
};



// WEBPACK FOOTER //
// ./src/modules/antd/index.ts